module.exports = __webpack_public_path__ + "static/dip-hero.ea6f15e0.webp";